// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_customButton__\\+GQSk {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font: var(--typography-body-m-medium);
  text-decoration: none;
  transition: all 0.2s ease;
  position: relative;
  outline: none;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  width: 100%;
  min-height: 44px;
}
@media (min-width: 768px) {
  .styles_customButton__\\+GQSk {
    min-height: auto;
  }
}

.styles_buttonContent__zeYSl {
  display: flex;
  align-items: center;
  gap: 8px;
}

.styles_buttonIcon__M\\+DQY {
  display: flex;
  align-items: center;
  justify-content: center;
}

.styles_buttonIcon__M\\+DQY img,
.styles_buttonIcon__M\\+DQY svg {
  width: 24px;
  height: 24px;
}

.styles_buttonText__zzDzB {
  line-height: 1;
}

.styles_customButton--primary__nZ0hb {
  background-color: var(--color-accent-blue);
  color: var(--color-white);
  border: 1px solid var(--color-accent-blue);
}
.styles_customButton--primary__nZ0hb svg,
.styles_customButton--primary__nZ0hb .styles_buttonIcon__M\\+DQY svg,
.styles_customButton--primary__nZ0hb .styles_buttonIcon__M\\+DQY img {
  filter: brightness(0) invert(1);
}
.styles_customButton--primary__nZ0hb:hover:not(:disabled):not(.styles_customButton--disabled__tmVD-) {
  background-color: var(--color-accent-hover);
  border-color: var(--color-accent-hover);
}
.styles_customButton--primary__nZ0hb:active:not(:disabled):not(.styles_customButton--disabled__tmVD-) {
  background-color: var(--color-accent-pressed);
  border-color: var(--color-accent-pressed);
}
.styles_customButton--primary__nZ0hb:disabled, .styles_customButton--primary__nZ0hb.styles_customButton--disabled__tmVD- {
  background-color: var(--color-button-disabled);
  border-color: var(--color-button-disabled);
  color: var(--color-text-secondary);
  cursor: not-allowed;
}

.styles_customButton--secondary__xFXQ- {
  background-color: var(--color-white);
  color: var(--color-black);
  border: 1px solid var(--color-gray-strokes);
}
.styles_customButton--secondary__xFXQ- svg,
.styles_customButton--secondary__xFXQ- .styles_buttonIcon__M\\+DQY svg,
.styles_customButton--secondary__xFXQ- .styles_buttonIcon__M\\+DQY img {
  filter: brightness(0);
}
.styles_customButton--secondary__xFXQ-:hover:not(:disabled):not(.styles_customButton--disabled__tmVD-) {
  background-color: var(--color-blue-light);
  border-color: var(--color-blue-light);
}
.styles_customButton--secondary__xFXQ-:active:not(:disabled):not(.styles_customButton--disabled__tmVD-) {
  background-color: var(--color-accent-blue);
  border-color: var(--color-accent-blue);
  color: var(--color-white);
}
.styles_customButton--secondary__xFXQ-:disabled, .styles_customButton--secondary__xFXQ-.styles_customButton--disabled__tmVD- {
  background-color: var(--color-button-disabled);
  border-color: var(--color-button-disabled);
  color: var(--color-text-secondary);
  cursor: not-allowed;
}

.styles_customButton--error__UcifX {
  background-color: var(--color-error);
  color: var(--color-white);
  border: 1px solid var(--color-error);
}
.styles_customButton--error__UcifX svg,
.styles_customButton--error__UcifX .styles_buttonIcon__M\\+DQY svg,
.styles_customButton--error__UcifX .styles_buttonIcon__M\\+DQY img {
  filter: brightness(0) invert(1);
}
.styles_customButton--error__UcifX:hover:not(:disabled):not(.styles_customButton--disabled__tmVD-) {
  background-color: #dc2626;
  border-color: #dc2626;
}
.styles_customButton--error__UcifX:active:not(:disabled):not(.styles_customButton--disabled__tmVD-) {
  background-color: #b91c1c;
  border-color: #b91c1c;
}
.styles_customButton--error__UcifX:disabled, .styles_customButton--error__UcifX.styles_customButton--disabled__tmVD- {
  background-color: var(--color-button-disabled);
  border-color: var(--color-button-disabled);
  color: var(--color-text-secondary);
  cursor: not-allowed;
}

.styles_customButton--small__VHwlr {
  padding: 8px 16px;
  font: var(--typography-body-s-medium);
  border-radius: 6px;
  min-height: 36px;
}
@media (min-width: 768px) {
  .styles_customButton--small__VHwlr {
    min-height: auto;
  }
}

.styles_customButton--medium__kr6Tg {
  padding: 8px 12px;
  font: var(--typography-button);
}

.styles_customButton--large__CkSTo {
  padding: 16px 32px;
  font: var(--typography-label);
  border-radius: 12px;
  min-height: 52px;
}
@media (min-width: 768px) {
  .styles_customButton--large__CkSTo {
    min-height: auto;
  }
}

.styles_customButton--fullWidth__rsCF5 {
  width: 100%;
}

.styles_customButton--iconOnly__518yK {
  padding: 12px;
  min-width: 44px;
  min-height: 44px;
}
.styles_customButton--iconOnly__518yK.styles_customButton--small__VHwlr {
  padding: 8px;
  min-width: 36px;
  min-height: 36px;
}
.styles_customButton--iconOnly__518yK.styles_customButton--large__CkSTo {
  padding: 16px;
  min-width: 52px;
  min-height: 52px;
}

.styles_customButton__\\+GQSk:focus-visible,
.styles_customButton--secondary__xFXQ-:focus-visible {
  outline: 2px solid var(--color-accent-blue);
  outline-offset: 2px;
}

.styles_customButton--loading__AyJWr {
  pointer-events: none;
  opacity: 0.7;
}
.styles_customButton--loading__AyJWr::after {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: styles_button-spin__uNoJW 1s linear infinite;
}

@keyframes styles_button-spin__uNoJW {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/button/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,qCAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAAF;ACVE;EDNF;IAmBI,gBAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;;EAEE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,0CAAA;EACA,yBAAA;EACA,0CAAA;AACF;AACE;;;EAGE,+BAAA;AACJ;AAEE;EACE,2CAAA;EACA,uCAAA;AAAJ;AAGE;EACE,6CAAA;EACA,yCAAA;AADJ;AAIE;EAEE,8CAAA;EACA,0CAAA;EACA,kCAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,oCAAA;EACA,yBAAA;EACA,2CAAA;AAJF;AAME;;;EAGE,qBAAA;AAJJ;AAOE;EACE,yCAAA;EACA,qCAAA;AALJ;AAQE;EACE,0CAAA;EACA,sCAAA;EACA,yBAAA;AANJ;AASE;EAEE,8CAAA;EACA,0CAAA;EACA,kCAAA;EACA,mBAAA;AARJ;;AAYA;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;AATF;AAWE;;;EAGE,+BAAA;AATJ;AAYE;EACE,yBAAA;EACA,qBAAA;AAVJ;AAaE;EACE,yBAAA;EACA,qBAAA;AAXJ;AAcE;EAEE,8CAAA;EACA,0CAAA;EACA,kCAAA;EACA,mBAAA;AAbJ;;AAiBA;EACE,iBAAA;EACA,qCAAA;EACA,kBAAA;EAEA,gBAAA;AAfF;ACxHE;EDkIF;IAQI,gBAAA;EAdF;AACF;;AAiBA;EACE,iBAAA;EACA,8BAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,6BAAA;EACA,mBAAA;EAEA,gBAAA;AAfF;ACzIE;EDmJF;IAQI,gBAAA;EAdF;AACF;;AAiBA;EACE,WAAA;AAdF;;AAiBA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AAdF;AAgBE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AAfJ;;AAmBA;;EAEE,2CAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,oBAAA;EACA,YAAA;AAhBF;AAkBE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kCAAA;EACA,kBAAA;EACA,uDAAA;AAhBJ;;AAoBA;EACE;IACE,uBAAA;EAjBF;EAmBA;IACE,yBAAA;EAjBF;AACF","sourcesContent":["@import \"mixins\";\n.customButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  font: var(--typography-body-m-medium);\n  text-decoration: none;\n  transition: all 0.2s ease;\n  position: relative;\n  outline: none;\n  user-select: none;\n  white-space: nowrap;\n  width: 100%;\n  min-height: 44px;\n\n  @include md {\n    min-height: auto;\n  }\n}\n\n.buttonContent {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.buttonIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.buttonIcon img,\n.buttonIcon svg {\n  width: 24px;\n  height: 24px;\n}\n\n.buttonText {\n  line-height: 1;\n}\n\n.customButton--primary {\n  background-color: var(--color-accent-blue);\n  color: var(--color-white);\n  border: 1px solid var(--color-accent-blue);\n\n  svg,\n  .buttonIcon svg,\n  .buttonIcon img {\n    filter: brightness(0) invert(1);\n  }\n\n  &:hover:not(:disabled):not(.customButton--disabled) {\n    background-color: var(--color-accent-hover);\n    border-color: var(--color-accent-hover);\n  }\n\n  &:active:not(:disabled):not(.customButton--disabled) {\n    background-color: var(--color-accent-pressed);\n    border-color: var(--color-accent-pressed);\n  }\n\n  &:disabled,\n  &.customButton--disabled {\n    background-color: var(--color-button-disabled);\n    border-color: var(--color-button-disabled);\n    color: var(--color-text-secondary);\n    cursor: not-allowed;\n  }\n}\n\n.customButton--secondary {\n  background-color: var(--color-white);\n  color: var(--color-black);\n  border: 1px solid var(--color-gray-strokes);\n\n  svg,\n  .buttonIcon svg,\n  .buttonIcon img {\n    filter: brightness(0);\n  }\n\n  &:hover:not(:disabled):not(.customButton--disabled) {\n    background-color: var(--color-blue-light);\n    border-color: var(--color-blue-light);\n  }\n\n  &:active:not(:disabled):not(.customButton--disabled) {\n    background-color: var(--color-accent-blue);\n    border-color: var(--color-accent-blue);\n    color: var(--color-white);\n  }\n\n  &:disabled,\n  &.customButton--disabled {\n    background-color: var(--color-button-disabled);\n    border-color: var(--color-button-disabled);\n    color: var(--color-text-secondary);\n    cursor: not-allowed;\n  }\n}\n\n.customButton--error {\n  background-color: var(--color-error);\n  color: var(--color-white);\n  border: 1px solid var(--color-error);\n\n  svg,\n  .buttonIcon svg,\n  .buttonIcon img {\n    filter: brightness(0) invert(1);\n  }\n\n  &:hover:not(:disabled):not(.customButton--disabled) {\n    background-color: #dc2626;\n    border-color: #dc2626;\n  }\n\n  &:active:not(:disabled):not(.customButton--disabled) {\n    background-color: #b91c1c;\n    border-color: #b91c1c;\n  }\n\n  &:disabled,\n  &.customButton--disabled {\n    background-color: var(--color-button-disabled);\n    border-color: var(--color-button-disabled);\n    color: var(--color-text-secondary);\n    cursor: not-allowed;\n  }\n}\n\n.customButton--small {\n  padding: 8px 16px;\n  font: var(--typography-body-s-medium);\n  border-radius: 6px;\n\n  min-height: 36px;\n\n  @include md {\n    min-height: auto;\n  }\n}\n\n.customButton--medium {\n  padding: 8px 12px;\n  font: var(--typography-button);\n}\n\n.customButton--large {\n  padding: 16px 32px;\n  font: var(--typography-label);\n  border-radius: 12px;\n\n  min-height: 52px;\n\n  @include md {\n    min-height: auto;\n  }\n}\n\n.customButton--fullWidth {\n  width: 100%;\n}\n\n.customButton--iconOnly {\n  padding: 12px;\n  min-width: 44px;\n  min-height: 44px;\n\n  &.customButton--small {\n    padding: 8px;\n    min-width: 36px;\n    min-height: 36px;\n  }\n\n  &.customButton--large {\n    padding: 16px;\n    min-width: 52px;\n    min-height: 52px;\n  }\n}\n\n.customButton:focus-visible,\n.customButton--secondary:focus-visible {\n  outline: 2px solid var(--color-accent-blue);\n  outline-offset: 2px;\n}\n\n.customButton--loading {\n  pointer-events: none;\n  opacity: 0.7;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    border: 2px solid transparent;\n    border-top: 2px solid currentColor;\n    border-radius: 50%;\n    animation: button-spin 1s linear infinite;\n  }\n}\n\n@keyframes button-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customButton": `styles_customButton__+GQSk`,
	"buttonContent": `styles_buttonContent__zeYSl`,
	"buttonIcon": `styles_buttonIcon__M+DQY`,
	"buttonText": `styles_buttonText__zzDzB`,
	"customButton--primary": `styles_customButton--primary__nZ0hb`,
	"customButton--disabled": `styles_customButton--disabled__tmVD-`,
	"customButton--secondary": `styles_customButton--secondary__xFXQ-`,
	"customButton--error": `styles_customButton--error__UcifX`,
	"customButton--small": `styles_customButton--small__VHwlr`,
	"customButton--medium": `styles_customButton--medium__kr6Tg`,
	"customButton--large": `styles_customButton--large__CkSTo`,
	"customButton--fullWidth": `styles_customButton--fullWidth__rsCF5`,
	"customButton--iconOnly": `styles_customButton--iconOnly__518yK`,
	"customButton--loading": `styles_customButton--loading__AyJWr`,
	"button-spin": `styles_button-spin__uNoJW`
};
export default ___CSS_LOADER_EXPORT___;
